import { ComboboxItem, Select, SelectProps } from '@mantine/core';
import { useGetBankAccounts } from 'api-hooks/bank-account';
import { NavigationRoutes } from 'common/constants';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
interface BankAccountSelectProps extends SelectProps {}

export default function BankAccountSelect(props: BankAccountSelectProps) {
  const { t } = useTranslation();
  const {
    required,
    label = t('common:bank_account'),
    placeholder = t('common:select_bank_account'),
    ...rest
  } = props;
  const { pathname } = useRouter();

  const _required = React.useMemo(() => {
    switch (pathname) {
      case NavigationRoutes.BankMutationReport:
        return true;
      default:
        return required;
    }
  }, [pathname, required]);

  const query = useGetBankAccounts({
    params: {
      limit: -1,
    },
  });

  const data: ComboboxItem[] = (query.data?.data || []).map((v) => ({
    value: v.id,
    label: v.name,
  }));
  return (
    <Select
      {...rest}
      required={_required}
      data={data}
      label={label}
      placeholder={placeholder}
      disabled={query.isLoading || props.disabled}
    />
  );
}
